import React from 'react';
import { Cushion, Typography, MaxWidth } from '@pitchero/react-ui';
import { Trans } from '../../../lib/i18n';

const NoResults = () => (
  <Cushion all="large" component="div">
    <MaxWidth component="div" maxWidth={280} center>
      <Cushion bottom="medium">
        <Typography preset="subtitle--large" color="dustygrey" component="div">
          <Trans i18nKey="teams:no_squad_member_results">
            There are currently no squad members listed for this team
          </Trans>
        </Typography>
      </Cushion>
    </MaxWidth>
  </Cushion>
);

export default NoResults;
